import { useEffect, useState } from 'react';
import { photoCache } from './photoCache';
import { constructPhotoUrl, checkImageLoads } from './photoUrls';

// Resolves the live/primary photo URL for a parcel and subscribes to photoCache so it updates
// whenever any component invalidates this parcel's photo (upload, set-primary, delete elsewhere).
export const usePhotoImage = (parcelId) => {
  const [revision, setRevision] = useState(0);
  const [imageExists, setImageExists] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    if (!parcelId) return undefined;
    return photoCache.subscribe(parcelId, () => setRevision((n) => n + 1));
  }, [parcelId]);

  const constructedUrl = constructPhotoUrl(parcelId);
  const actualUrl = photoCache.getPhoto(parcelId) || photoCache.getBustedUrl(parcelId, constructedUrl);

  useEffect(() => {
    if (!actualUrl) {
      setImageExists(false);
      setImageLoading(false);
      return undefined;
    }
    let cancelled = false;
    setImageLoading(true);
    checkImageLoads(actualUrl).then((exists) => {
      if (cancelled) return;
      setImageExists(exists);
      setImageLoading(false);
    });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualUrl, revision]);

  return {
    actualUrl,
    hasPhoto: imageExists && !imageLoading,
    imageLoading,
  };
};
